<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style lang="scss">
$navbar-height: 5rem;
$navbar-item-img-max-height: 3rem;
$navbar-padding-horizontal: 4rem;
$navbar-item-hover-color: #3590bf;
@import "../node_modules/bulma/bulma.sass";
@import url("https://fonts.googleapis.com/css?family=Staatliches|Ubuntu:300,400,500,700");
#app {
  font-family: "Staatliches", cursive;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue